export const getRecentNews = (news, now = new Date()) => {
  // Compare calendar days in the visitor's timezone, independent of build time.
  const today = new Date(
    Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())
  )

  return news
    .filter(({ publishedAt }) => {
      if (
        typeof publishedAt !== "string" ||
        !/^\d{4}-\d{2}-\d{2}$/.test(publishedAt)
      ) {
        return false
      }

      const publishedDate = new Date(`${publishedAt}T00:00:00Z`)
      if (
        Number.isNaN(publishedDate.getTime()) ||
        publishedDate.toISOString().slice(0, 10) !== publishedAt
      ) {
        return false
      }

      const expiresOn = new Date(publishedDate)
      expiresOn.setUTCDate(1)
      expiresOn.setUTCMonth(expiresOn.getUTCMonth() + 6)
      const lastDayOfMonth = new Date(
        Date.UTC(expiresOn.getUTCFullYear(), expiresOn.getUTCMonth() + 1, 0)
      ).getUTCDate()
      expiresOn.setUTCDate(Math.min(publishedDate.getUTCDate(), lastDayOfMonth))

      // An item remains visible on its six-month anniversary.
      return publishedDate <= today && today <= expiresOn
    })
    .sort((first, second) =>
      second.publishedAt.localeCompare(first.publishedAt)
    )
}
